// extracted by mini-css-extract-plugin
export default {"container":"q0-z","heading":"r0-z","links":"s0-z","copy":"t0-z","subCopy":"u0-z","linksLeft":"v0-z","linksCenter":"w0-z","linksRight":"x0-z","link":"y0-z","onlyLink":"z0-z"};